export default __webpack_public_path__ + "static/media/2.e6530d01.png";